/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { connect } from 'react-redux';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { State } from '../../../../../redux/root-reducer';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const incomeHistoryView: React.FC<Props> = ({ classes, formDetails }: Props) => {
    const incomeDetails = formDetails?.lifeAssured?.incomeDetails;
    return (
        <>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Income Details
                    </Typography>
                </Grid>
            </Grid>

            <Paper className={classes.paper}>
                <Grid container spacing={2} className={classes.marginTop2}>
                    {incomeDetails?.incomeType === 'Self employed fee based professional' ||
                        (incomeDetails?.incomeType === 'Self employed fee based professional' && (
                            <>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Which of the following items describe your income?"
                                        value={incomeDetails?.incomeType}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Did you submit a proof of income to Liberty at inception,reinstatement or when an ''adhoc'' increase was done to the policy"
                                        value={incomeDetails?.proofOfIncomeSubmitted}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="What was your total earnings for the 12 months immediately prior to the date of disability or impairment?"
                                        value={incomeDetails?.totalAmountEarned}
                                    />
                                </Grid>
                            </>
                        ))}
                    {incomeDetails?.incomeType === 'Salaried person' && (
                        <>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Did you submit a proof of income to Liberty at inception,reinstatement or when an ''adhoc'' increase was done to the policy"
                                    value={incomeDetails?.proofOfIncomeSubmitted}
                                />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Which of the following items describe your income?"
                                    value={incomeDetails?.incomeType}
                                />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="What was your taxable income (income before deductions) for the past 12 months immediately prior to the date of disability or impairment??"
                                    value={incomeDetails?.totalAmountEarned}
                                />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label=" What was your Cost to Company for past 12 months immediately prior to the date of disability or impairment?"
                                    value={incomeDetails?.costToCompany}
                                />
                            </Grid>
                        </>
                    )}

                    {incomeDetails?.incomeType === 'Commission earner and Salaried Person' && (
                        <>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Did you submit a proof of income to Liberty at inception,reinstatement or when an ''adhoc'' increase was done to the policy"
                                    value={incomeDetails?.proofOfIncomeSubmitted}
                                />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Which of the following items describe your income?"
                                    value={incomeDetails?.incomeType}
                                />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="What was your basic taxable for the past 12 months immediately prior to the date of disability or impairment??"
                                    value={incomeDetails?.totalAmountEarned}
                                />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="What was your commission earned over the past 12 months immediately prior to the date of disability or impairment?"
                                    value={incomeDetails?.totalAmountCommissionEarned}
                                />
                            </Grid>

                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="If you were earning an hourly rate, what was the rate earned per hour for the past 12 months immediately prior to the date of disability or impairment?"
                                    value={incomeDetails?.totalRateEarned}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Paper>
        </>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const IncomeHistoryView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(incomeHistoryView));
